<template>
  <div class="photoMaterial">
    <div>
      <el-row :gutter="20">
        <el-col :sm="12" :md="6" :lg="4">
          <el-button type="primary" @click="photoVisible = true">上传图片</el-button>
        </el-col>
        <el-col :sm="12" :md="18" :lg="20" style="text-align:right">
          <el-input
            style="width:200px;margin-right:10px"
            placeholder="请输入图片名称"
            auto-complete="off"
            v-model="searchForm.name"
            clearable
            @keyup.enter.native="page.pageNumber = 1,pageList()"
          ></el-input>
          <el-button type="primary" @click="page.pageNumber = 1,pageList()">查询</el-button>
        </el-col>
      </el-row>
    </div>
    <div style="display:flex;margin-top:10px">
      <div class="photoMaterial-left">
        <div class="photoMaterial-left-title">
          图片分组
        </div>
        <div class="photoMaterial-left-input">
          <el-input
            placeholder="请输入分组名称"
            v-model="searchFodderGroupForm.name"
            auto-complete="off"
            @keyup.enter.native="getFodderGroupInfoTree"
          >
            <i class="el-icon-search el-input__icon" slot="suffix" @click="getFodderGroupInfoTree"></i>
          </el-input>
        </div>
        <el-tree
          :data="fodderGroupInfoList"
          :props="defaultProps"
          :highlight-current="true"
          :expand-on-click-node="false"
          class="research-tree"
          ref="tree"
          node-key="id"
          current-node-key
        >
          <span class="span-ellipsis" slot-scope="{ node, data }">
            <span @click="treeClick(data)">
              <i style="color:#409eff;font-size:14px" class="icon iconfont2 icon-wenjian"></i>
              <span style="margin-left:10px">{{ data.name }}</span>
              <div class="material_operation" v-if="data.name!=='全部图片'&&data.name!=='默认分组'">
              </div>
            </span>
          </span>
        </el-tree>
      </div>
      <div class="photoMaterial-right">
        <el-table
          ref="multipleTable"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-background="rgba(255, 255, 255, 0.8)"
          :data="page.rows"
          tooltip-effect="dark"
          style="margin-top: 0px; width: 100%;"
          border
          @selection-change="selectionChange"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="name" label="图片" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div class="flex-starts">
                <img height="50" :src="scope.row.url" />
                <div style="margin-left:5px;">{{scope.row.name}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="size" label="大小" width="180">
            <template slot-scope="scope">{{(scope.row.size/1024/1024).toFixed(4)}}MB</template>
          </el-table-column>
          <el-table-column prop="createTime" label="上传时间" width="180"></el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            layout="total, prev, pager, next"
            style="margin-top: 20px;text-align: right;"
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </div>

      <div slot="footer" class="dialog-footer" style="text-align:right;margin-top:20px;">
        <!-- <el-button @click="addFormVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="dialogSubmit()">确 定</el-button>
      </div>
      </div>
      <el-dialog
        title="上传图片"
        :visible.sync="photoVisible"
        width="800px"
        left
        :close-on-click-modal="false"
      >
        <el-form
          ref="addPhotoForm"
          :model="addPhotoForm"
          :label-width="formLabelWidth"
          :rules="addPhotoFormRules"
        >
          <el-form-item label="上传到" prop="id">
            <!-- <el-input style="width:100%" v-model="addPhotoForm.name" placeholder="请输入分组名称"></el-input> -->
            <el-cascader
              clearable
              v-model="addPhotoForm.id"
              :show-all-levels="false"
              placeholder="请选择"
              :options="fodderGroupInfoList"
              :props="props"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="本地文件">
            <el-upload
              class="avatar-uploader"
              ref="upload"
              action
              :http-request="amountFileUploadRequest"
              :on-remove="amountHandleRemove"
              list-type="picture-card"

              multiple
            >
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="photoVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="addAttachmentPhoto()"
            :loading="addAttachmentPhotoBlock"
          >确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="编辑图片"
        :visible.sync="editPhotoVisible"
        width="400px"
        left
        :close-on-click-modal="false"
      >
        <el-form
          ref="editPhotoForm"
          :model="editPhotoForm"
          :label-width="formLabelWidth"
          :rules="editPhotoFormRules"
        >
          <el-form-item label="名称" prop="name">
            <el-input style="width:100%" v-model="editPhotoForm.name" placeholder="请输入图片名称"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="photoVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateAttachment()" :loading="updateAttachmentBlock">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="添加分组"
        :visible.sync="groupsVisible"
        width="400px"
        left
        :close-on-click-modal="false"
      >
        <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
          <el-form-item label="分组名称" prop="name">
            <el-input
              style="width:100%"
              v-model="addForm.name"
              maxlength="10"
              placeholder="请输入分组名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="groupsVisible = false">取 消</el-button>
          <el-button type="primary" @click="addFodderGroupInfo">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="素材移动到"
        :visible.sync="moveVisible"
        width="400px"
        left
        :close-on-click-modal="false"
      >
        <el-tree
          :data="fodderGroupInfoList"
          :props="defaultProps"
          :highlight-current="true"
          :expand-on-click-node="false"
          class="research-tree"
          ref="tree"
          node-key="id"
          current-node-key
        >
          <span class="span-ellipsis" slot-scope="{ node, data }">
            <span @click="transferTreeClick(data)">
              <i style="color:#409eff;font-size:14px" class="icon iconfont2 icon-wenjian"></i>
              <span style="margin-left:10px">{{ data.name }}</span>
            </span>
          </span>
        </el-tree>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="moveVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="编辑分组名称"
        :visible.sync="editGroupsVisible"
        width="400px"
        left
        :close-on-click-modal="false"
      >
        <el-form
          ref="editGroupsForm"
          :model="editGroupsForm"
          :label-width="formLabelWidth"
          :rules="editGroupsFormRules"
        >
          <el-form-item label="名称" prop="name">
            <el-input style="width:100%" v-model="editGroupsForm.name" placeholder="请输入分组名称"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="editGroupsVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="updateFodderGroupInfo()"
            :loading="updateAttachmentBlock"
          >确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { uploadTC } from "../../upload/tecent";
import axios from "axios";
import { uploadOSS } from "../../upload/upload";
export default {
  props: {
    number: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      addAttachmentPhotoBlock: false,
      updateAttachmentBlock: false,
      updateFodderGroupInfoBlock: false,
      editPhotoVisible: false,
      editGroupsVisible: false,
      selectSubmit: 1,
      fileActive: 0,
      dialogFileActive: 0,
      groupsVisible: false,
      photoVisible: false,
      moveVisible: false,
      formLabelWidth: "80px",
      addForm: {
        name: null,
        parentId: null,
        type: 1
      },
      addPhotoForm: {
        id: null,
        attachmentList: []
      },
      editPhotoForm: {},
      editGroupsForm: {},
      fodderGroupInfoList: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      props: {
        value: "id",
        children: "children",
        label: "name"
      },
      searchForm: {
        type: 1,
        fodderGroupInfoId: null,
        name: null
      },
      searchFodderGroupForm: {
        type: 1,
        name: null
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      editPhotoFormRules: {
        name: [
          {
            required: true,
            message: "请输入分组名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 10,
            message: "分组名称长度在1到10个字"
          }
        ]
      },
      editGroupsFormRules: {
        name: [
          {
            required: true,
            message: "请输入分组名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 10,
            message: "分组名称长度在1到10个字"
          }
        ]
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入分组名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 10,
            message: "分组名称长度在1到10个字"
          }
        ]
      },
      addPhotoFormRules: {
        id: {
          required: true,
          message: "请选择分组",
          trigger: "change"
        }
      },
      loading: false,
      id: null,
      ids: [],
      fodderGroupInfoName: name,
      selectPhoto: null
    };
  },
  methods: {

    /*---------------------------提交-------------------------*/
    dialogSubmit(){
      if(this.ids.length==0){
        this.$message.error("请选择图片！")
        return;
      } else if(this.ids.length > this.number) {
        this.$message.error("请选择" + this.number + "张及以内图片!")
        return;
      }
      this.$emit("photoListChange",this.ids)
    },

    /*---------------------------pagelist操作-------------------------*/
    treeClick(data) {
      this.id = data.id;
      this.fodderGroupInfoName = data.name;
      if (data.name == "全部图片") {
        this.searchForm.fodderGroupInfoId = "";
      } else {
        this.searchForm.fodderGroupInfoId = data.id;
      }
      this.pageList();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    pageList() {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.api.attachment
        .pageList(this.searchForm)
        .then(result => {
          this.loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.$emit("attachmentSizeChange",true);
        })
        .catch(error => {
          console.log(error);
        });
    },

    selectionChange(val) {
      this.ids = val;
    },

    edit(row) {
      this.editPhotoForm = row;
      this.editPhotoVisible = true;
    },

    updateAttachment() {
      if (this.updateAttachmentBlock) {
        return;
      }
      this.updateAttachmentBlock = true;
      this.api.fodderGroupInfo
        .updateAttachment(this.editPhotoForm)
        .then(res => {
          if (res.success) {
            this.updateAttachmentBlock = false;
            this.editPhotoVisible = false;
            this.pageList();
          } else {
            this.updateAttachmentBlock = false;
            this.$message.success(res.message);
          }
        });
    },

    down(row) {
      window.open(row.url);
    },

    deleteVideo(row) {
      this.$confirm("将会删除该图片，是否确认删除？", "系统消息", {
        type: "warning"
      }).then(() => {
        let obj = {
          id: row.id
        };
        this.api.attachment.deleteAttachment([obj]).then(res => {
          if (res.success) {
            this.$message.success(res.message);
            this.pageList();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    delectVideoList() {
      if (this.ids.length == 0) {
        this.$message.warning("请选择需要删除的图片！");
      } else {
        this.$confirm("将会删除选中图片，是否确认删除？", "系统消息", {
          type: "warning"
        }).then(() => {
          this.api.attachment.deleteAttachment(this.ids).then(res => {
            if (res.success) {
              this.$message.success(res.message);
              this.pageList();
            } else {
              this.$message.error(res.message);
            }
          });
        });
      }
    },

    selectTransferFodder(num) {
      if (num == 1) {
        if (this.ids.length == 0) {
          this.$message.warning("请选中需要移动的图片！");
        } else {
          this.moveVisible = true;
        }
      } else {
        if (
          this.fodderGroupInfoName == "全部图片" ||
          this.fodderGroupInfoName == "默认分组"
        ) {
          this.$message.warning("默认分组不可以转移图片！");
        } else {
          this.moveVisible = true;
        }
      }
      this.selectSubmit = num;
    },

    transferTreeClick(data) {
      this.fodderGroupInfoId = data.id;
    },

    submit() {
      if (this.selectSubmit == 1) {
        this.transferFodder();
      } else {
        this.transferFodderByFodderGroupInfoId();
      }
    },

    transferFodder() {
      let obj = {
        id: this.fodderGroupInfoId,
        attachmentList: this.ids
      };
      this.api.fodderGroupInfo.transferFodder(obj).then(res => {
        if (res.success) {
          this.$message.success(res.message);
          this.page.pageNumber = 1
          this.pageList();
          this.moveVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    transferFodderByFodderGroupInfoId() {
      let obj = {
        fodderGroupInfoId: this.fodderGroupInfoId,
        id: this.id
      };
      this.api.fodderGroupInfo
        .transferFodderByFodderGroupInfoId(obj)
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
            this.page.pageNumber = 1
            this.pageList();
            this.moveVisible = false;
          } else {
            this.$message.error(res.message);
          }
        });
    },

    /*---------------------------上传图片-------------------------*/

    amountFileUploadRequest(file) {
      const isJPG = file.file.type.indexOf("image") > -1;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 100) {
        this.$message.error("图片大小不能超过100M");
      } else {
        uploadOSS(file, "image").then(result => {
          console.log("result", result);
          let obj = {
            name: file.file.name,
            size: file.file.size,
            type: file.file.type,
            url: result
          };
          this.addPhotoForm.attachmentList.push(obj);
        });
      }
    },
    amountHandleRemove(file) {
      for (let index in this.addPhotoForm.attachmentList) {
        if (
          file.name == this.addPhotoForm.attachmentList[index].name &&
          file.size == this.addPhotoForm.attachmentList[index].size
        ) {
          this.addPhotoForm.attachmentList.splice(index, 1);
        }
      }
    },

    addAttachmentPhoto() {
      this.$refs.addPhotoForm.validate().then(valid => {
        if (valid) {
          if (this.addAttachmentPhotoBlock) {
            return;
          }
          if (this.addPhotoForm.attachmentList.length == 0) {
            return this.$message.error("请选择需要上传的文件");
          }
          this.addAttachmentPhotoBlock = true;
          let len = this.addPhotoForm.id.length;
          this.addPhotoForm.id = this.addPhotoForm.id[len - 1];
          this.api.fodderGroupInfo
            .addAttachment(this.addPhotoForm)
            .then(res => {
              if (res.success) {
                this.addAttachmentPhotoBlock = false;
                this.photoVisible = false;
                this.pageList();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
              } else {
                this.addAttachmentPhotoBlock = false;
                this.$message.error(res.message);
              }
            });
        }
      });
    },

    /*---------------------------分组管理-------------------------*/
    getFodderGroupInfoTree() {
      if (this.searchFodderGroupForm.name == "") {
        this.searchFodderGroupForm.name = null;
      }
      this.api.fodderGroupInfo
        .getFodderGroupInfoTree(this.searchFodderGroupForm)
        .then(res => {
          if (res.success) {
            this.fodderGroupInfoList = res.data;
            this.$nextTick(function() {
              this.$refs.tree.setCurrentKey(res.data[0].id);
              this.id = res.data[0].id;
              this.fodderGroupInfoName = res.data[0].name;
            });
            this.pageList();
          } else {
            this.$message.error(res.message);
          }
        });
    },
    addFodderGroupInfo() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.fodderGroupInfo
            .addFodderGroupInfo(this.addForm)
            .then(res => {
              if (res.success) {
                this.$message.success(res.message);
                this.getFodderGroupInfoTree();
                this.groupsVisible = false;
              } else {
                this.$message.error(res.message);
              }
            });
        }
      });
    },
    rename(row) {
      this.editGroupsForm = row;
      this.editGroupsVisible = true;
    },
    updateFodderGroupInfo() {
      if (this.updateFodderGroupInfoBlock) {
        return;
      }
      this.updateFodderGroupInfoBlock = true;
      this.$refs.editGroupsForm.validate().then(valid => {
        if (valid) {
          this.api.fodderGroupInfo
            .updateFodderGroupInfo(this.editGroupsForm)
            .then(res => {
              if (res.success) {
                this.$message.success(res.message);
                this.editGroupsVisible = false;
                this.getFodderGroupInfoTree();
              } else {
                this.$message.error(res.message);
              }
            });
        }
      });
    },
    deleteFodderGroupInfo(id) {
      this.api.fodderGroupInfo.deleteFodderGroupInfo({ id: id }).then(res => {
        if (res.success) {
          this.$message.success(res.message);
          this.getFodderGroupInfoTree();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  },
  mounted() {
    this.getFodderGroupInfoTree();
  },
  watch: {
    groupsVisible: function(newVal) {
      if (!newVal) {
        this.addForm.name = "";
      } else {
      }
    },
    photoVisible: function(newVal) {
      if (!newVal) {
        this.addPhotoForm.id = null;
        this.addPhotoForm.attachmentList = [];
      } else {
      }
    }
  }
};
</script>
<style scoped>
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.photoMaterial-left {
  width: 220px;
  border: 1px solid #eee;
  padding: 20px 0px;
  flex-shrink: 0;
}
.photoMaterial-right {
  width: 100%;
}
.photoMaterial-left-title {
  padding: 0 20px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
}
.photoMaterial-left-input {
  padding: 0 20px;
  margin-bottom: 8px;
}
.iconPlus {
  float: right;
  font-size: 16px;
  font-weight: 600;
}
.photoMaterial-left-file {
  padding: 8px 20px;
  cursor: pointer;
}
.photoMaterial-left-file:hover {
  background: rgba(238, 245, 255, 1);
}
.photoMaterial-left-file_active {
  padding: 8px 20px;
  cursor: pointer;
  background: rgba(238, 245, 255, 1);
}
.photoMaterial-button {
  cursor: pointer;
  color: #4d94ff;
  padding: 2px 8px;
  border: 1px solid #4d94ff;
  margin-left: 10px;
  line-height: 22px;
}

.el-upload--picture-card {
  width: 80px !important;
  height: 80px;
  display: block;
}
.material_operation {
  float: right;
  color: #409eff;
  margin-right: 20px;
}
</style>


<style lang="less" rel="stylesheet/less">
.photoMaterial {
  .el-tree-node__content {
    height: 35px;
  }
  .avatar-uploader {
    display: flex;
    flex-wrap: wrap;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 80px;
    height: 80px;
    line-height: 80px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
  }
  .el-upload-list--picture-card {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/photoMaterial.vue